import React, { ForwardedRef, forwardRef } from 'react';
import classNames from 'classnames';
import { useId } from '@floating-ui/react';
import * as styles from './ComboBoxList.module.scss';
import { Button } from 'components/core';

type ComboBoxListItemProps = {
  children: React.ReactNode;
  isActive: boolean;
};

const ComboBoxListItem = (
  { children, isActive, ...rest }: ComboBoxListItemProps,
  ref: ForwardedRef<HTMLButtonElement>
) => {
  const id = useId();

  return (
    <Button
      isNaked
      role="option"
      ref={ref}
      id={id}
      size="sm"
      aria-selected={isActive}
      className={classNames(styles.ListItem, {
        [styles.Active]: isActive,
      })}
      {...rest}
    >
      {children}
    </Button>
  );
};

const forwardedComboBoxListItem = forwardRef<
  HTMLButtonElement,
  ComboBoxListItemProps
>(ComboBoxListItem);
export { forwardedComboBoxListItem as ComboBoxListItem };
